import * as React from 'react';
import './auditData.scss';
import { getAllViews } from '../../utils';
import { formatDate, parseDate } from '../../utils';
import { useSelector } from '../../utils/useSelector';

type Props = {
  dataType: 'view' | 'schema';
};

export const AuditData = ({ dataType }: Props) => {
  const viewModal = useSelector(s => s.viewModal);
  const selectedWorkspace = useSelector(s => s.planning?.selectedWorkspace);
  const schemaModal = useSelector(s => s.schemaModal);

  let auditData = null;
  if (dataType == 'view') {
    const allViews = getAllViews(selectedWorkspace);
    const viewRefId = viewModal?.refId;
    const selectedView = allViews?.filter(
      view => view?.props?.refId === viewRefId
    );
    auditData = selectedView?.length > 0 ? selectedView[0]?.auditData : null;
  } else if (dataType == 'schema') {
    const schemaRefId = schemaModal?.refId;
    const selectedSchema = selectedWorkspace?.schemas?.filter(
      schema => schema?.props?.refId === schemaRefId
    );
    auditData =
      selectedSchema?.length > 0 ? selectedSchema[0]?.auditData : null;
  }

  const createdDateTime = parseDate(auditData?.createdTime);
  const modifiedDateTime = parseDate(auditData?.modifiedTime);
  return (
    <div className="audit-data">
      {!!auditData?.createdEmpCd && (
        <div className="audit-data-group">
          <b>
            <div>Created By/On </div>
          </b>
          ({auditData.createdEmpCd}) {auditData.createdEmpName} on{' '}
          {formatDate(createdDateTime)} at{' '}
          {createdDateTime.toLocaleTimeString()}
        </div>
      )}
      {!!auditData?.modifiedEmpCd && (
        <div className="audit-data-group">
          <b>
            <div>Last Modified By/On </div>
          </b>
          ({auditData.modifiedEmpCd}) {auditData.modifiedEmpName} on{' '}
          {formatDate(modifiedDateTime)} at{' '}
          {modifiedDateTime.toLocaleTimeString()}
        </div>
      )}
    </div>
  );
};
